






































import { PropType } from 'vue';
import {
  Configuration,
  ConfigurationItem
} from '@/models/configurator/configuration';
import { mapActions } from 'vuex';

import mixins from '@/utils/mixins';

import { DataTableHeader } from 'vuetify';
import draggable from '@/mixins/draggable';
import VueDraggable from 'vuedraggable';
import { cloneDeep } from 'lodash';

export default mixins(draggable).extend({
  components: {
    VueDraggable
  },

  props: {
    configuration: {
      type: Object as PropType<Configuration>
    },

    configurationItems: {
      type: Array as PropType<ConfigurationItem[]>
    },

    exchangeRate: Number,
    currencyCode: String
  },

  data: () => ({
    search: '',
    configurationItemsHeaders: [
      {
        text: '',
        align: 'start',
        width: 30,
        maxWidth: 30,
        sortable: false,
        value: 'draggable'
      },
      {
        text: '',
        align: 'center',
        sortable: false,
        width: 20
      },
      {
        text: 'Items',
        align: 'start',
        sortable: false,
        value: 'item',
        width: '250'
      },
      {
        text: 'Unit Price',
        value: 'unit_price',
        sortable: false,
        width: '200'
      },
      { text: 'Quantity', value: 'quantity', sortable: false, width: '150' },
      { text: 'U/M', value: 'unit', sortable: false, width: '120' },
      { text: 'Sub Total', value: 'subtotal', sortable: false, width: '120' },
      {
        text: '',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: '50'
      }
    ] as DataTableHeader[]
  }),

  methods: {
    ...mapActions({
      fetchConfigurationItems:
        'configuratorConfiguration/fetchConfigurationItems',

      updateConfigurationItem:
        'configuratorConfiguration/updateConfigurationItem',

      deleteConfigurationItem:
        'configuratorConfiguration/deleteConfigurationItem'
    }),

    getConfigurationItems() {
      return this.fetchConfigurationItems(this.configuration.id);
    },

    async destroyConfigurationItem(item: ConfigurationItem) {
      const confirm = (this as any).$refs.confirm;

      if (
        await confirm.open(
          'Delete Item',
          {},
          `<span style="line-height: 19px;">Are you sure you want to delete <strong class="text--primary" style="word-break: normal">${item.item}</strong>? <br /> This action cannot be undone.</span>`
        )
      ) {
        this.deleteConfigurationItem(item).then(() => {
          this.getConfigurationItems().then(itemList => {
            this.$emit('update:configurationItems', itemList);
          });
        });
      }
      return;
    },

    async updateConfigurationItembyQuantity(item: ConfigurationItem) {
      // Not using store to keep local copy of configitems list
      this.getConfigurationItems().then(itemList => {
        this.$emit('update:configurationItems', itemList);
      });
    },

    updateItemOrder() {
      this.isDragging = false;

      const items = cloneDeep(this.configurationItems).map(
        (item, index: number) => {
          item.order = index + 1;
          // Work-around - LH-2022-09-23- Need to delete description
          //  - to ensure configurable item description is translatable
          delete item.description;
          return item;
        }
      );

      items.forEach(item => this.updateConfigurationItem(item));
    }
  },

  mounted() {
    this.getConfigurationItems().then(itemList => {
      this.$emit('update:configurationItems', itemList);
    });
  }
});
